/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetPressReleaseResponseData,
    GetPressReleaseResponseDataFromJSON,
    GetPressReleaseResponseDataFromJSONTyped,
    GetPressReleaseResponseDataToJSON,
} from './GetPressReleaseResponseData';

/**
 * get /press_release/{release_id}
 * @export
 * @interface GetPressReleaseResponse
 */
export interface GetPressReleaseResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPressReleaseResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPressReleaseResponse
     */
    message: string;
    /**
     * 
     * @type {GetPressReleaseResponseData}
     * @memberof GetPressReleaseResponse
     */
    data: GetPressReleaseResponseData;
}

export function GetPressReleaseResponseFromJSON(json: any): GetPressReleaseResponse {
    return GetPressReleaseResponseFromJSONTyped(json, false);
}

export function GetPressReleaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': GetPressReleaseResponseDataFromJSON(json['data']),
    };
}

export function GetPressReleaseResponseToJSON(value?: GetPressReleaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': GetPressReleaseResponseDataToJSON(value.data),
    };
}

